import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import '@/style/index.less'
import permission from '@/directives/permission'
                    
const app = createApp(App)
app.use(store)
app.use(router)
app.use(Antd)
// 注册权限指令
app.directive('permission', permission)
app.mount('#app')
